export default __webpack_public_path__ + "static/media/lidar-platform-icon.766e3c00.svg";